import * as Types from '../../../generated/gqlTypes';

import { gql } from '@apollo/client';
export type AddressFragment = { id: string, pk: number, firstName: string, lastName: string, companyName: string, streetAddress1: string, streetAddress2: string, country: string, city: string, countryArea: string, phone: string, postalCode: string, defaultAddress: boolean, defaultBillingAddress: boolean, defaultShippingAddress: boolean };

export const AddressFragmentDoc = gql`
    fragment AddressFragment on AddressType {
  id
  pk
  firstName
  lastName
  companyName
  streetAddress1
  streetAddress2
  country
  city
  countryArea
  phone
  postalCode
  defaultAddress
  defaultBillingAddress
  defaultShippingAddress
}
    `;